import Cookies from 'js-cookie';
import apiClient from '@Hooks/useGlobalRequestHandler';
window.isLoggingOut = window.isLoggingOut || false;

class UserAuthService {
    constructor() {
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_AUTH = '/api/userauth';

        this.LOGIN = '/login';
        this.LOGOUT = '/logout';
        this.SESSION_CHECK = '/session';
        this.SESSION_AND_PERMISSION_CHECK = '/session/permission';
        this.PASSWORD = '/password';
        this.GET_USER_LOGIN_METHOD = '/login-method';
        this.SEND_LOGIN_OTP = '/login-otp';
        this.DELETE_USER = '/delete';
        this.VERIFY_PASSWORD = '/verify/password';
        this.GET_ACCESS_LIST_FOR_USER = '/list/access/user/{userId}';
        this.UPDATE_ORG_LIST_FOR_USER = '/org/list';
        this.FORGOT_PASSWORD_RESET = '/forgotpassword';
        this.GET_USER_PERMISSIONS = '/permission/user/{userId}';
        this.GET_USER_OWNER_PERMISSION_LIST = '/list/permission/owner/user/{userId}';
        this.GET_USER_PERMISSION_FOR_PARENT = '/permission/user/{userId}/parent/{parentType}/{parentId}';
        this.GET_TEAM_PERMISSION_FOR_PARENT = '/permission/team/{teamId}/parent/{parentType}/{parentId}';
    }

    getCsrfToken() {
        return Cookies.get('XSRF-TOKEN');
    }

    handleSessionError(data) {
        if (data.error === 'Session Expired') {
            this.logout();
        } else if (data.uuid) {
            localStorage.setItem('errorUUID', data.uuid);
        }
    }

    async login(credentials) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.LOGIN;
            const csrfToken = this.getCsrfToken();
            return await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(credentials)
            }).then(data => {
                window.isLoggingOut = false;
                return data.json()
            })
        } catch(err) {
            console.log(err);
        }
    }

    async sendLoginOTP(body) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.SEND_LOGIN_OTP;
            const csrfToken = this.getCsrfToken();
            return await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(body)
            }).then(data => {
                window.isLoggingOut = false;
                return data.json()
            })
        } catch(err) {
            console.log(err);
        }
    }

    async logout() {
        try{
            if (window.isLoggingOut) return;
            window.isLoggingOut = true;
            let newUrl = window.location.origin
            window.history.pushState({path:newUrl},'',newUrl);
            localStorage.setItem('errorMessage', 'Your Session has expired, Please login again!');
            const url = window.location.origin + this.USER_AUTH + this.LOGOUT;
            const csrfToken = this.getCsrfToken();
            await this.fetch(url, {
                method: 'POST',
                headers: {
                    'X-XSRF-TOKEN': csrfToken
                },
            });
            apiClient.cancelAll();
            window.location.href = newUrl + '/#/logout';
        } catch(err) {
            console.log(err);
        }
    }

    async sessionCheck() {
        const url = window.location.origin + this.USER_AUTH + this.SESSION_CHECK;
        try {
            const response = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async sessionAndPermissionCheck(bodyMap) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.SESSION_AND_PERMISSION_CHECK;
            const csrfToken = this.getCsrfToken();
            const response = await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyMap)
            });
            if (response.status === 204) return { body: '' };
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async verifyPassword(credentials) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.VERIFY_PASSWORD;
            const csrfToken = this.getCsrfToken();
            const response = await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(credentials)
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserLoginMethod(bodyMap) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.GET_USER_LOGIN_METHOD;
            const csrfToken = this.getCsrfToken();
            const response = await this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyMap)
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async updatePassword(userData) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.PASSWORD;
            const csrfToken = this.getCsrfToken();
            const response = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(userData)
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async getAccessListForUser(userId) {
        let url = window.location.origin + this.USER_AUTH + this.GET_ACCESS_LIST_FOR_USER.replace('{userId}', userId);
        try {
            const response = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserPermissions(userId) {
        let url = window.location.origin + this.USER_AUTH + this.GET_USER_PERMISSIONS.replace('{userId}', userId);
        try {
            const response = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserOwnerPermissionList(userId) {
        let url = window.location.origin + this.USER_AUTH + this.GET_USER_OWNER_PERMISSION_LIST.replace('{userId}', userId);
        try {
            const response = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserPermissionForParent(userId, parentType, parentId) {
        if (userId !== localStorage.getItem('activeUserId')) {
            return await this.getUserPermissionForParentRefetch(userId, parentType, parentId);
        }
        try {
            parentType = parentType === 'org' ? 'orgs' : (parentType === 'project' ? 'projects' : 'teams');
            let parentPermission;
            let activeUserPermission = !!localStorage.getItem('activeUserPermissions') ? JSON.parse(localStorage.getItem('activeUserPermissions')) : {};
            if(!!activeUserPermission) {
                parentPermission = activeUserPermission[parentType][parentId];
                return { body: JSON.stringify(parentPermission)}
            }
            if(Object.keys(parentPermission).length === 0) {
                return await this.getUserPermissionForParentRefetch(userId, parentType, parentId);
            }
            return await this.getUserPermissionForParentRefetch(userId, parentType, parentId);
        } catch (err) {
            console.log(err);
        }
    }

    async getUserPermissionForParentRefetch(userId, parentType, parentId) {
        let url = window.location.origin + this.USER_AUTH + this.GET_USER_PERMISSION_FOR_PARENT
            .replace('{userId}', userId)
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const response = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async getTeamPermissionForParent(teamId, parentType, parentId) {
        let url = window.location.origin + this.USER_AUTH + this.GET_TEAM_PERMISSION_FOR_PARENT
            .replace('{teamId}', teamId)
            .replace('{parentType}', parentType)
            .replace('{parentId}', parentId);
        try {
            const response = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async forgotPasswordReset(passwordData) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.FORGOT_PASSWORD_RESET;
            const csrfToken = this.getCsrfToken();
            const response = await this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(passwordData)
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }

    async deleteUser(deleteMap) {
        try {
            const url = window.location.origin + this.USER_AUTH + this.DELETE_USER;
            const csrfToken = this.getCsrfToken();
            const response = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteMap)
            });
            const data = await response.json();
            if (data.error !== undefined) this.handleSessionError(data);
            return data;
        } catch (err) {
            console.log(err);
        }
    }
}

export default UserAuthService;
